import { render } from "./my-playlist.vue?vue&type=template&id=6a21dd4e&ts=true"
import script from "./my-playlist.vue?vue&type=script&lang=ts"
export * from "./my-playlist.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__